

































import Vue from 'vue';
// @ts-ignore
import DateRangePicker from '@mobi-components/vue2-daterange-picker';
import '@mobi-components/vue2-daterange-picker/dist/vue2-daterange-picker.css';
import {DateRange} from './trip-inputs-helper';
import {DateFormatter} from '@/services/date-helpers';

type BooleanMap = {
  [key: string]: boolean;
};

export default Vue.extend({
  components: {
    DateRangePicker,
  },
  props: {
    dateRangeMode: Boolean,
    initialStartDate: Number,
    initialEndDate: Number,
    minDate: Date,
    invalidDate: Boolean,
    label: String,
    noBorder: Boolean,
  },
  computed: {
    dateValueFormatted(): string {
      if (!this.startDate()) {
        return '';
      }

      return DateFormatter.formatDateRange(this.startDate(), this.endDate());
    },

    currentDateRange(): DateRange {
      return {startDate: this.startDate(), endDate: this.endDate()};
    },
  },
  methods: {
    dateCssClasses(classes: BooleanMap, date: Date): BooleanMap {
      if (!classes.disabled) {
        classes.disabled = date.getTime() < new Date().getTime();
      }
      return classes;
    },

    startDate() {
      return this.initialStartDate ? new Date(this.initialStartDate) : undefined;
    },

    endDate() {
      return this.initialEndDate ? new Date(this.initialEndDate) : undefined;
    },

    // TODO: this code is bugged
    calculatePosition(
      dropdownList: HTMLElement,
      style: CSSStyleDeclaration,
      component: object,
      {top, left}: {top: number; left: number},
    ): void {
      dropdownList.style.right = 'auto';
      dropdownList.style.top = top - dropdownList.clientHeight + 'px';
      dropdownList.style.left = left + 'px';
    },

    getDateRange(): DateRange {
      // TODO: change this. Look at logic in select-dates.vue
      // range is today + 60 days
      const startDate = this.minDate ? new Date(this.minDate) : new Date();
      const endDate = new Date();
      endDate.setDate(startDate.getDate() + 60);

      return {startDate, endDate};
    },

    onDateSelected(dateRange: DateRange): void {
      this.$emit('dates-selected', dateRange);
    },
  },
});
